import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';
import {
  ICard,
  ICreditCardStatus,
  CreditCardsService
} from './../../services/credit-cards.service';
import { DialogStateService } from '../../../dialogs/services/dialog-state.service';
import { Subscription } from 'rxjs';
import { FullPortfolioViewService } from '../../../shared/services/full-portfolio-view.service';

@Component({
  selector: 'ab-credit-cards-overview',
  templateUrl: './credit-cards-overview.component.html',
  styleUrls: ['./credit-cards-overview.component.scss']
})
export class CreditCardsOverviewComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  public cards: Array<ICard>;
  public CreditCardStatus = ICreditCardStatus;
  public creditCardStatusMap = [];
  public isLoading = true;
  public isPortfolioCif7 = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private dialogStateService: DialogStateService,
    private creditCardsService: CreditCardsService,
    private fullPortfolioViewService: FullPortfolioViewService
  ) {}

  ngOnInit() {
    this.creditCardStatusMap[
      ICreditCardStatus.ACTIVE
    ] = this.rendering.fields.statuses[0].fields.label.value;
    this.creditCardStatusMap[
      ICreditCardStatus.BLOCKED
    ] = this.rendering.fields.statuses[1].fields.label.value;
    this.creditCardStatusMap[
      ICreditCardStatus.UNLINKED
    ] = this.rendering.fields.statuses[2].fields.label.value;

    this.getCards();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getCards(): void {
    this.subscriptions.push(
      this.fullPortfolioViewService.bankAccounts.subscribe(() => {
        this.subscriptions.push(
          this.creditCardsService.getCreditCards().subscribe(
            response => {
              this.isLoading = false;
              this.cards = response.cards;
              this.isPortfolioCif7 =
                this.cards !== null && this.cards.length > 0;
            },
            () => (this.isLoading = false)
          )
        );
      })
    );
  }

  changeStatus(card: ICard): void {
    if (card.status === this.CreditCardStatus.ACTIVE) {
      this.dialogStateService
        .openDialog('unlink-card-confirmation', [card.name, card.suffix])
        .subscribe(confirm => this.confirm(confirm, card));
    }
  }

  confirm(confirm: boolean, card: ICard): void {
    if (confirm) {
      this.creditCardsService.unlinkCreditCard(card.suffix).subscribe(() => {
        this.getCards();
      });
    }
  }
}
